export default {"src":"/_next/static/media/logo-blue-header.9a18472d.svg","height":37,"width":73,"blurWidth":0,"blurHeight":0};